// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type AuthenticationUrlRequest from '../contract/AuthenticationUrlRequest';

export default function authenticationUrlRequest(
    data: AuthenticationUrlRequest
): AuthenticationUrlRequest {
    const result: AuthenticationUrlRequest = {
        __type: 'AuthenticationUrlRequest:#Exchange',
        ...data,
    };

    return result;
}
